export function getDevice() {
  let device = window.getComputedStyle(document.body, '::after').getPropertyValue('content')
  device = device.replace(/('|")/g, '')

  return device
}

export function isMobile() {
  return !(getDevice() !== 'sm' && getDevice() !== 'xs')
}

export function isSafari() {
  return (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1)
}

export function isTouchDevice() {
  return window.matchMedia('(pointer: coarse) and (hover: none)').matches;
}

export const getLineLength = (line) => {
  const x1 = line.getAttribute('x1')
  const x2 = line.getAttribute('x2')
  const y1 = line.getAttribute('y1')
  const y2 = line.getAttribute('y2')
  const lineLength = Math.sqrt(Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2))
  return lineLength
}

export const getTotalLength = (polyline) => {
  if (polyline.tagName !== 'polyline') return polyline.getTotalLength()
  let totalLength = 0
  let prevPos
  for (let i = 0; i < polyline.points.numberOfItems; i += 1) {
    const pos = polyline.points.getItem(i)

    if (i > 0) {
      totalLength += Math.sqrt(Math.pow((pos.x - prevPos.x), 2) + Math.pow((pos.y - prevPos.y), 2))
    }
    prevPos = pos
  }
  return totalLength
}

export const getMixedLength = (element) => {
  if (element.tagName === 'line') return getLineLength(element)
  return getTotalLength(element)
}

export function lerp(a, b, n) {
  return ((1 - n) * a) + (n * b)
}



// WEBPACK FOOTER //
// ./src/scripts/utils.js